import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import "../../assets/css/save.css";
import "../../assets/css/favorites.css";
import { API } from "../../services/api";
import Favoritesimg from "../../assets/img/fovr-img.svg"
import MakeFavourite from "../Posts/popups/MakeFavourite";


const Favorites = (props) => {
  const navigate = useNavigate();
  const [showfav, setFavourite] = useState(false);
  const [reportId, setReportId] = useState(false);
  const [favouriteUserId, setFavouriteUserId] = useState(false);
  const [favouriteUserName, setFavouriteUserName] = useState("");
  const [favourites, setFavourites] = useState({});
  const [FavStatus, setFavStatus] = useState(true);
  
  const showFavourite = (userId,favName) => {
    setFavourite(true);
    setFavouriteUserId(userId);
    setFavouriteUserName(favName);
  }
  const HideFavourite = () => {
    setFavourite(false);
  }
  const toggleFavourite = (userId, newstatus) => {
    const isUsrId = favourites[userId];
    props.getUser()

  };
const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");

  const handleImageClick = (first, last, id,type) => {
    if(type === "individual"){
        const userName = `${slugify(first)}-${slugify(last)}`;
      
       navigate(`/profile/${userName}`, { state: { userId: id } })
    }else{
       
        navigate(`/organization/${slugify(first)}`, { state: { userId: id } })
    }
   
  };
  return (
    <div>
      <div className="row">
        {Array.isArray(props.Favorite) && props.Favorite.length > 0 && props.Favorite.map((fav, index) => (
          <div className="col-12 col-sm-6 col-md-4 mb-2" key={fav._id || index}>
            <div className="Favorites-div d-flex justify-content-between align-items-center community-card p-2">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={fav.favouriteMemberId?.profileImage?.url ? API.uploadFilePath + fav.favouriteMemberId?.profileImage?.url : Favoritesimg}
                  alt="test"
                  className="community_thumb" onClick={() => {
                        handleImageClick(fav.favouriteMemberId.firstName,fav.favouriteMemberId.lastName,fav.favouriteMemberId._id,fav.favouriteMemberId.userType);
                        }}    
                />
                <span className="letter-width text-truncate">{fav.favouriteMemberId.firstName + " " + fav.favouriteMemberId.lastName}</span>
              </div>
              <div>
                <span
                  className="three-dots d-none d-sm-inline"
                  onClick={() => showFavourite(fav.favouriteMemberId._id,fav.favouriteMemberId.firstName + " " + fav.favouriteMemberId.lastName)}
                >
                  &#8942;
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <MakeFavourite
        showFavourite={showfav}
        HideFavourite={HideFavourite}
        favouriteUserId={favouriteUserId}
        toggleFavourite={toggleFavourite}
        FavStatus={FavStatus}
        favouriteUserName={favouriteUserName}
      />
    </div>


  );

};
export default Favorites;
